import { PortableText } from '@portabletext/react';
import imageUrlBuilder from '@sanity/image-url'
import { client } from '../../sanityClient' // your configured sanity client
const builder = imageUrlBuilder(client)

const urlFor = (source) => builder.image(source)

const components = {
  marks: {
    en: ({ children }) => (
      <span className="font-outfit">{children}</span>
    ),
    jp: ({ children }) => (
      <span className="font-kleeone">{children}</span>
    ),
    pointColorText: ({ children }) => (
      <span className="point-color-text">{children}</span>
    ),
    link: ({ children, value }) => {
      const { href, openInNewTab } = value || {}
      return (
        <a
          href={href}
          target={openInNewTab ? "_blank" : "_self"}
          rel={openInNewTab ? "noopener noreferrer" : undefined}
          className="underline"
        >
          {children}
        </a>
      );
    },
  },
  block: {
    normal: ({ children }) => (
      <p className="font-outfit">{children}</p>
    ),
    h2: ({ children }) => (
      <h2 className="font-outfit">{children}</h2>
    ),
    h3: ({ children }) => (
      <h3 className="font-outfit">{children}</h3>
    ),
    // add more as needed (h3, blockquote, etc.)
    normal_jp: ({ children }) => (
      <p className="font-kleeone">{children}</p>
    ),
    h2_jp: ({ children }) => (
      <h2 className="font-kleeone">{children}</h2>
    ),
    h3_jp: ({ children }) => (
      <h3 className="font-kleeone">{children}</h3>
    ),
  },
  list: {
    bullet: ({ children }) => (
      <ul className="">{children}</ul>
    ),
    number: ({ children }) => (
      <ol className="">{children}</ol>
    ),
  },
  listItem: {
    listItem: ({ children }) => (
      <li className="">{children}</li>
    ),
  },
  types: {
    image: ({ value }) => {
      if (!value?.asset?._ref) return null; // safety check
      return (
        <div className="flex justify-center my-6">
          <img
            style={{ maxWidth: "100%" }}
            src={urlFor(value).url()} // build proper URL ....width(800)
            alt={value.alt || ""}
            className="" // your styling
          />
        </div>
      );
    },
  },
};

const colorClassMap = {
    pink: '', // no extra class
    orange: 'left-progress-title',
    purple: 'left-active-title',
};


const ClassesSection = ({ title, titleJP, titleBackgroundColor, titleBackgroundSize, id, subtitles, tags, contentEN, contentJP }) => {
  return (
    <div className="classes-section">
      <div className="classes-view-section">
        <div className="container classes-view-main">
            <section id={id} className="classes-item-section">
                <div className="classes-item-title">
                    <div className="left-section">
                        {/* mid-title, big-title */}
                        <p
                            className={`left-title font-amaticsc-bold ${colorClassMap[titleBackgroundColor] || ''}
                                ${titleBackgroundSize}`}
                        >
                            {title}
                        </p>
                    <p className="left-subtitle font-kleeone">{titleJP}</p>
                    </div>
                    
                    { subtitles && (
                        <div className="right-section">
                            {subtitles.map((value, index) => {
                                return (
                                    <p className="text1 font-amaticsc-bold" key={index}>
                                        {value.subtitleEN}
                                        <span className="text2 font-zenkurenaido">{value.subtitleJP}</span>
                                    </p>
                                );
                            })}
                        </div>
                    )}

                    { tags && (
                        <div className="third-section">
                            {tags.map((value, index) => {
                            return (
                                <p className="text1 font-amaticsc-bold" key={index}>
                                    {value.tagEN}
                                    <span className="text2 font-zenkurenaido">{value.tagJP}</span>
                                </p>
                            );
                            })}
                        </div>
                    )}
                </div>
                <div className="classes-item-content">
                    { contentEN && (
                        <div className="portable-text-container prose max-w-none w-full mx-0 prose-p:my-0 left-text font-outfit">
                            <PortableText value={contentEN} components={components} />
                        </div>
                    )}

                    { contentJP && (
                        <div className="portable-text-container prose max-w-none w-full mx-0 prose-p:my-0 right-text font-kleeone">
                            <PortableText value={contentJP} components={components} />
                        </div>
                    )}
                </div>
                <hr className="bottom-line" />
            </section>
        </div>
      </div>
    </div>
  );
};

export default ClassesSection;